import React from "react";

const TermsAccepted = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <div className="mx-auto max-w-4xl px-6 py-12">
        <h1 className="mb-6 text-3xl font-semibold">Termini accettati</h1>
        <p className="text-lg text-gray-700">
          Grazie per aver accettato i Termini e Condizioni di Minigoal. Puoi
          chiudere questa pagina e continuare a utilizzare l&apos;applicazione.
        </p>
      </div>
    </div>
  );
};

export default TermsAccepted;
